export default "__VITE_ASSET__CKMJw6sV__"